/**
 * safeRedirectPath — open-redirect prevention helper.
 *
 * Returns `s` only when it is a safe relative path:
 *   - starts with "/"
 *   - does NOT start with "//" (protocol-relative URL — resolves off-origin)
 *
 * Any other value (absolute URL, javascript: URI, backslash path, bare domain,
 * undefined, or empty string) returns `fallback` instead.
 *
 * Use this on every `?redirectTo` query parameter before passing it to
 * `redirect()`, `NextResponse.redirect()`, or `window.location.href`.
 *
 * @example
 *   safeRedirectPath("/photographer/images", "/photographer/images") // → "/photographer/images"
 *   safeRedirectPath("https://evil.com", "/photographer/images")     // → "/photographer/images"
 *   safeRedirectPath("//evil.com", "/photographer/images")           // → "/photographer/images"
 *   safeRedirectPath(undefined, "/photographer/images")              // → "/photographer/images"
 */
export function safeRedirectPath(
  s: string | undefined,
  fallback: string,
): string {
  if (!s) return fallback;
  // Must start with "/" but not "//" (protocol-relative attacks)
  if (s.startsWith("/") && !s.startsWith("//")) return s;
  return fallback;
}
